import React, {type FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/react';
import {boxedInputColorReaders} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/boxedInputConstants';
import {DropdownBoxCoordinator} from '../../../../../../../libs/shared/ui/src/components/boxedInputs/dropdownBoxCoordinator';
import {TagModel} from '../../../../../../models/api/tagModel';
import {SearchHintTagDropdown} from '../../../hints/searchHintTag/searchHintTagDropdown';
import {renderTagsPillTitle} from '../../../hints/searchHintTag/searchHintTagItem';
import {useTagsFromQuery} from '../../../hints/searchModifiersHooks';
import {BuiltQuery} from '../builtQuery';

type MultiSelectTagsDropdownProps = {
  builtQuery: BuiltQuery;
  onSelectedTagsChange: (tags: ReadonlyArray<TagModel>) => void;
};

const StyledPlaceholderSpan = styled.span`
  color: ${boxedInputColorReaders.textPlaceholder};
`;

export const MultiSelectTagsDropdown: FC<MultiSelectTagsDropdownProps> = ({
  builtQuery,
  onSelectedTagsChange,
}) => {
  const selectedTags = useTagsFromQuery(builtQuery.render());
  return (
    <DropdownBoxCoordinator
      leftIcon={selectedTags.length === 0 ? 'tagSmall' : undefined}
      value={
        selectedTags.length > 0 ? (
          renderTagsPillTitle(selectedTags)
        ) : (
          <StyledPlaceholderSpan>
            <Trans id="search-query-builder-tags-placeholder">Select tag</Trans>
          </StyledPlaceholderSpan>
        )
      }
      renderDropdown={(popoverProps) => (
        <SearchHintTagDropdown
          popoverProps={popoverProps}
          selectedTags={selectedTags}
          onSelectedTagsChange={onSelectedTagsChange}
        />
      )}
      shouldDisablePadding
    />
  );
};
